import React from 'react';
import { createRoot } from 'react-dom/client';
import {
  LTTheme,
  LTThemeProvider
} from '@lambdatestincprivate/lt-components';
import '@lambdatestincprivate/lt-components/lib/index.css';
import App from './App';
import './index.css';

const container = document.getElementById('root');
if (container) {
  createRoot(container).render(
    <React.StrictMode>
      <LTThemeProvider theme={LTTheme} dayScheme="light">
        <App />
      </LTThemeProvider>
    </React.StrictMode>
  );
}
